import React     from 'react';
import PropTypes from 'prop-types';
import Parent    from 'pu-react/components/EmailQuote';
import { Modal } from 'react-bootstrap';
import { START } from 'pu-data/QuoteSteps';

class EmailQuote extends Parent {
  handleShow() {
    if (this.props.canShow) {
      if (this.props.parameters !== undefined) {
        if (this.props.parameters.part_number !== undefined)
          this.setState({ part_number: this.props.parameters.part_number });

        if (this.props.parameters.revision !== undefined)
          this.setState({ revision: this.props.parameters.revision });
      }
      this.setState({ show: this.props.canShow() });
    }
  }
}

EmailQuote.propTypes = {
  canShow: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired,
}

class EmailQuoteWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.canShowEmailForm = this.canShowEmailForm.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      showAlert: false,
      message  : '',
    };
  }

  toggleAlert() {
    this.setState({ showAlert: !this.state.showAlert });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  handleClose() {
    this.setState({ showAlert: false });
  }

  canShowEmailForm() {
    let message = null;
    if (this.props.quoteStep === START) {
      message = 'You must get a quote before sending an email.';
    } else if (this.props.parametersChanged) {
      message = 'One or more parameters have changed. Please get a new quote';
    }
    this.setState({
      showAlert: message !== null,
      message,
    });
    return message === null;
  }

  render() {
    return (
      <React.Fragment>
        <EmailQuote {...this.props} canShow={this.canShowEmailForm} />
        <Modal show={this.state.showAlert} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{'Can\'t send email'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <button type="button" onClick={this.handleClose} className="btn btn-primary">OK</button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

EmailQuoteWrapper.propTypes = {
  quoteStep: PropTypes.string.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  parameters: PropTypes.object.isRequired,
}

export default EmailQuoteWrapper;
